module.exports = __webpack_public_path__ + "static/media/in-progress.d9cd7a05.svg";